export const selectAllVideos = state => state.videos.allVideos
export const selectTotalVideos = state => state.videos.total
export const selectProducerVideos = state => state.videos.producerVideos
export const selectManuals = state => state.videos.manuals
export const selectAppVideos = state => state.videos.appVideos
